import { TO_STRING } from '@core/util/string.util'
import { environment } from '@env/environment'

const env: any = environment

export const ENV_SERVER_TYPE = env.serverType

export const ENV_SERVER_TYPE_DEV = env.serverType === 'DEV'
export const ENV_SERVER_TYPE_DEVLOCAL = env.serverType === 'DEVLOCAL'
export const ENV_SERVER_TYPE_TEST = env.serverType === 'TEST'
export const ENV_SERVER_TYPE_DEMO = env.serverType === 'DEMO'
export const ENV_SERVER_TYPE_PREPROD = env.serverType === 'PREPROD'
export const ENV_SERVER_TYPE_PROD = env.serverType === 'PROD'

export const ENV_CDMX = env.context === 'cdmx'
export const ENV_MONTREAL = env.context === 'montreal'
export const ENV_PARIS = env.context === 'paris'
export const ENV_ACTV = env.context === 'actv'
export const ENV_ER = env.context === 'er'

export const ENV_CSN_DEC_NUMBER = env.csnDisplay === 'dec_number'
export const ENV_CSN_HEX_NUMBER = env.csnDisplay === 'hex_number'
export const ENV_CSN_HEX_CARD = env.csnDisplay === 'hex_card'

export const ENV_ROOT_ADMIN_SALES_PAGE = TO_STRING(env.rootAdminSalesPage)

// demo only : when true the auth guard is skipped so the UI can be viewed without login
export const ENV_DEMO_BYPASS_AUTH = env.demoBypassAuth === true

// demo only : credentials used to auto-login at startup so backend calls carry a valid JWT
export const ENV_DEMO_ACCOUNT = TO_STRING(env.demoAccount)
export const ENV_DEMO_PASSWORD = TO_STRING(env.demoPassword)

export const ENV_APP_VERSION = env.appVersion
